import type { Schema } from 'features/yieldbirdWrapperAgent/forms/GenerateReportForm/schema'
import type { FieldError, FieldErrors } from 'react-hook-form'

export const toFirstUrlErrorMessage = (error: FieldErrors<Schema>['urls']): string | undefined =>
  Array.isArray(error)
    ? error.find((urlError: FieldError | undefined): boolean => urlError?.message !== undefined)
        ?.message
    : undefined
